import { createRoot } from 'react-dom/client';

import { App } from 'app/app';
import bootstrap from './bootstrap';

import './global.scss';

const container = document.getElementById('root');
const root = createRoot(container);

bootstrap().then(() => {
  root.render(<App />);
});
